import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileAudio = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 216,
	viewBox: "0 0 165 216",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.67 49.24C134.203 49.2347 128.961 47.0606 125.095 43.1947C121.229 39.3288 119.055 34.0871 119.05 28.62V0H26.91C19.773 0 12.9284 2.83514 7.88177 7.88174C2.83517 12.9283 0 19.773 0 26.91V189.13C0.0105984 196.26 2.85042 203.094 7.89587 208.132C12.9413 213.17 19.7799 216 26.91 216H137.52C144.652 216 151.492 213.169 156.538 208.129C161.583 203.089 164.422 196.252 164.43 189.12V49.24H139.67Z",
				fill: "#FF3E4C"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.43 49.24H139.67C134.203 49.2347 128.961 47.0606 125.095 43.1947C121.229 39.3288 119.055 34.0871 119.05 28.62V0L164.43 49.24Z",
			fill: "#FF3E4C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M120.23 131.92H109.28V87.6601C109.28 86.1775 108.691 84.7557 107.643 83.7074C106.594 82.659 105.173 82.0701 103.69 82.0701H75.69C74.9559 82.0701 74.229 82.2147 73.5508 82.4956C72.8726 82.7765 72.2563 83.1883 71.7372 83.7074C71.2182 84.2264 70.8064 84.8427 70.5255 85.5209C70.2446 86.1991 70.1 86.926 70.1 87.6601V131.92H59.1V83.9201C59.1 82.2357 59.432 80.5678 60.0768 79.0118C60.7217 77.4557 61.6669 76.042 62.8584 74.8514C64.0499 73.6609 65.4644 72.7168 67.0209 72.0731C68.5775 71.4294 70.2456 71.0988 71.93 71.1001H107.43C110.83 71.1001 114.091 72.4508 116.495 74.855C118.899 77.2592 120.25 80.52 120.25 83.9201L120.23 131.92Z",
			fill: "#FF3E4C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.25 144.9C114.419 144.9 120.23 139.089 120.23 131.92C120.23 124.751 114.419 118.94 107.25 118.94C100.081 118.94 94.27 124.751 94.27 131.92C94.27 139.089 100.081 144.9 107.25 144.9Z",
			fill: "#FF3E4C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.18 144.9C64.3486 144.9 70.16 139.089 70.16 131.92C70.16 124.751 64.3486 118.94 57.18 118.94C50.0113 118.94 44.2 124.751 44.2 131.92C44.2 139.089 50.0113 144.9 57.18 144.9Z",
			fill: "#FF3E4C"
		})
	]
});
export default SvgIconFileAudio;
